import { render, staticRenderFns } from "./RiskIndexResearchDetail.vue?vue&type=template&id=000e296c&scoped=true"
import script from "./RiskIndexResearchDetail.vue?vue&type=script&lang=js"
export * from "./RiskIndexResearchDetail.vue?vue&type=script&lang=js"
import style0 from "./RiskIndexResearchDetail.vue?vue&type=style&index=0&id=000e296c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000e296c",
  null
  
)

export default component.exports